import defaultCaregiverPhoto from 'assets/experts-woman-light.png';
import { Card, CardContent } from 'components/ui/card';
import { PhotoTint } from 'components/ui/photo-tint';
import { RegisteredCaregiverDTO } from 'services/api/models/RegisteredCaregiverDTO';
import { shortName } from 'hooks/useCaregivers';

/** A caregiver of the team: photo, name and job (Figma "Carte métier"). Opens her profile. */
export default function CaregiverCard({
  caregiver,
  onClick,
}: {
  caregiver: RegisteredCaregiverDTO;
  onClick: () => void;
}) {
  const { first_name, last_name, display_name, caregiver_groups } = caregiver.caregiver;

  return (
    <button type="button" onClick={onClick} data-testid="caregiver-card" className="cursor-pointer text-left">
      {/* The photo bleeds to the card's edges */}
      <Card className="h-full gap-2 overflow-hidden pt-0 pb-3">
        <div className="relative">
          <img src={caregiver.user.photo_url || defaultCaregiverPhoto} alt="" className="h-28 w-full object-cover" />
          <PhotoTint />
        </div>
        <CardContent className="flex flex-col gap-0.5 px-3">
          <span className="text-sm font-medium text-foreground">{shortName(first_name, last_name, display_name)}</span>
          {caregiver_groups[0] && (
            <span className="text-xs font-bold tracking-widest text-secondary-foreground uppercase">
              {caregiver_groups[0].display_name}
            </span>
          )}
        </CardContent>
      </Card>
    </button>
  );
}
